export enum BankMatchState {
  NOT_CLEARED,
  AUTO_CLEARED,
}

export enum BankTransactionType {
  INSURANCE,
  OTHER,
}

export enum BankTransactionStatus {
  AUTO_MATCHED,
  MANUALLY_MATCHED,
  POSTED_OUTSIDE,
  MISSING,
  DUPLICATE,
  REVERSED,
}
